import {
    Col,
    Layout,
    Row,
    Typography,
    Card,
    Menu,
    Divider,
    Dropdown,
    Avatar,
    Button,
    Space,
    Image,
    Modal,
    notification,
    Drawer,
} from "antd";

import React, { useEffect, useState } from "react";
import logono1 from "../../src/Image/logoFmr.png";
import icon_logo from "../../src/Image/icon_logo.png";
import logofmrgg from "../../src/Image/logoFmr2.png";
import R from "@routers/R";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Cookies, useCookies } from "react-cookie";
import {
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
    CK_TYPE,
} from "@constant/constant";
import {
    UserOutlined,
    LogoutOutlined,
    SafetyCertificateOutlined,
    FileProtectOutlined,
    LockOutlined,
    RollbackOutlined,
    FileTextOutlined,
    AppstoreOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    VideoCameraOutlined,
    UploadOutlined,
    ExportOutlined,
    FormOutlined,
    FileDoneOutlined,
    FieldTimeOutlined,
    SyncOutlined,
    MenuOutlined,
    CaretDownOutlined,
} from "@ant-design/icons";
import { APIEndpointWeb, webapi } from "@client/web";
import ModalPolicy from "@pages/AllModal/ModalPolicy/ModalPolicy";
// import ModalTermsAndConditions from "@pages/ModalTermsAndConditions/ModalTermsAndConditions";
import NewPasswordLogin from "@pages/AllSetting/NewPasswordLogin";
import ModalTermsOfUse from "@pages/AllModal/ModalCheckEkyc/ModalTermsOfUse/ModalTermsOfUse";

const { Text } = Typography;
const { Header, Sider, Content } = Layout;
export interface userDisplay {
    insurer: string;
    name: string;
    ref_code: string;
    account_type: string;
}

const SuperAdminLayout: React.FC = (props): JSX.Element => {
    const [goToPath, setGoToPath] = useState("");
    const history = useHistory();
    let location = useLocation();
    const route = useRouteMatch();
    const [resUserDisplay, setResUserDisplay] = useState<userDisplay>();
    const [WindowResize, setWindowResize] = useState(Number);
    const getCookies = new Cookies();
    const [isModalTermsAndConditions, setIsModalTermsAndConditions] = useState(
        false
    );
    const [isModalOpenPolicy, setIsModalOpenPolicy] = useState(false);
    const [showModalResetPassword, setShowModalResetPassword] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [defaultSelectedKeys, setdefaultSelectedKeys] = useState(["1"]);
    const [open, setOpen] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies([
        CK_SHARED_TOKEN,
        CK_ACCESS_TOKEN,
        CK_ACCESS_DATA_ROLE,
        CK_TYPE,
    ]);

    const handleGoToPath = (path: string): void => {
        setGoToPath(path);
    };
    const { children } = props;
    useEffect(() => {
        // getuserdisplay();
        checkCookie();
        // const interval = setInterval(() => {
        // checkCookie();
        // }, 1500);
        // return () => clearInterval(interval);
    }, [route, cookies.shared_token]);

    const shared_token = getCookies.get("shared_token");
    useEffect(() => { }, [shared_token]);
    useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        handleWindowResize();
    }, [WindowResize]);

    useEffect(() => {
        if (location.pathname === "/dashboard-insurance") {
            setdefaultSelectedKeys(["1"]);
        } else if (location.pathname === "/manage-user") {
            setdefaultSelectedKeys(["2"]);
        }
        // setdefaultSelectedKeys()
    }, []);

    const handleWindowResize = () => {
        setWindowResize(window.innerWidth);
    };
    const showModal1 = () => {
        setIsModalTermsAndConditions(true);
    };
    const handleOk1 = () => {
        setIsModalTermsAndConditions(false);
    };

    const handleCancel1 = () => {
        setIsModalTermsAndConditions(false);
    };
    const showModal2 = () => {
        setIsModalOpenPolicy(true);
    };

    const handleOk2 = () => {
        setIsModalOpenPolicy(false);
    };

    const handleCancel2 = () => {
        setIsModalOpenPolicy(false);
    };
    const showModal3 = () => {
        setShowModalResetPassword(true);
    };

    const handleOk3 = () => {
        setShowModalResetPassword(false);
    };

    const handleCancel3 = () => {
        setShowModalResetPassword(false);
    };
    const checkCookie = () => {
        // var type = getCookies.get("type");
        webapi.get(`${APIEndpointWeb.checkCookie}`,
            {
                withCredentials: true,
            }
        ).then(() => {
            getuserdisplay()
        }).catch((error) => {
            console.log(error.response);
            if (error.response.status === 401) {
                history.push("/login");
            }
        })
        // var shared_token1 = getCookies.get("shared_token");
        // if (
        //   (!(Object.keys(cookies).length === 0 && cookies.constructor === Object)) || ((cookies.shared_token === shared_token1) === true)
        // ) {
        //   if ((cookies.shared_token === shared_token1) === false) {
        //     handleMenuClick();
        //     window.location.replace("/login");
        //   }
        // } else {
        //   notification.error({
        //     message: "คุณใช้งานระบบเกินระยะเวลาที่กำหนด กรุณาเข้าสู่ระบบอีกครั้ง",
        //   });
        //   handleMenuClick();
        //   window.location.replace("/login");
        // }
    };
    const getuserdisplay = async () => {
        try {
            const { data } = await webapi.get(`${APIEndpointWeb.GetUserDisplay}`, {
                // headers: { Authorization: `Bearer ${cookies.shared_token}` },
                withCredentials: true,
            });
            setResUserDisplay(data.result);
        } catch (error) {
            if (error === "Unauthorized") {
                window.location.replace("/login");
            }
            // }
        }
    };

    const checkpathname = () => {
        switch (window.location.pathname) {
            case "/dashboard-superadmin":
                return "รายการขอประวัติการรักษา"
            case "/newpassword-login":
                return "ตั้งค่ารหัสผ่านใหม่";
            case "/manage-user":
                return "จัดการผู้ใช้งาน";
            default:
                return "รายการขอประวัติการรักษา";
        }
    };
    const handleMenuClick = (): any => {
        webapi.post(`${APIEndpointWeb.logout}`,
            {
                withCredentials: true,
            }
        ).then(() => {

        }).catch((error) => {
            console.log(error.response);
        })
        history.replace("/login");
    };

    const showConfirm = (): any => {
        Modal.confirm({
            title: "คุณต้องการออกจากระบบใช่หรือไม่",
            // content: 'ลงชื่อออก',
            okText: "ตกลง",
            cancelText: "ยกเลิก",
            okButtonProps: {
                type: "primary",
            },
            cancelButtonProps: {
                type: "default",
            },
            onOk() {
                setTimeout(() => {
                    handleMenuClick();
                }, 1000);
            },
            onCancel() {
                // console.log('can');
            },
        });
    };

    // const handleOpenChange = (flag: any) => {
    //   setOpen(flag);
    // };

    const menu = (
        <Row
            className="mr-4"
            justify="center"
            style={{
                borderRadius: "20px",
                backgroundColor: "#B6D3D6",
                width: "34vh",
            }}
        >
            <Col
                className="pl-2 pr-2"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
            >
                <Card
                    style={{
                        backgroundColor: "#26334A",
                        borderRadius: "20px 20px 0px 0px",
                    }}
                >
                    <Row style={{ textAlign: "center" }}>
                        <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                            <Avatar size="large" icon={<UserOutlined />} />
                        </Col>
                        <Col
                            xs={18}
                            sm={18}
                            md={18}
                            lg={18}
                            xl={18}
                            xxl={18}
                            className="mt-2"
                        >
                            <Text style={{ color: "#ffffff", fontSize: "16px" }}>
                                {resUserDisplay?.name}
                            </Text>
                        </Col>
                    </Row>
                </Card>
                <Row>
                    <Col
                        className="pl-2 pr-2"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        style={{
                            backgroundColor: "#26334A",
                            borderRadius: "0px 0px 20px 20px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Text
                            className="mt-2 mb-2"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                        >
                            {resUserDisplay?.insurer}
                        </Text>
                    </Col>
                </Row>

                <Row className="pt-2 pb-2" style={{ backgroundColor: "#B6D3D6" }}>
                    <Menu mode="inline" style={{ backgroundColor: "#B6D3D6 " }}>
                        <Menu.Item
                            key="1"
                            // onClick={(): void => {
                            //   handleGoToPath(R.HomeRouter.newpasswordlogin.link);
                            // }}
                            onClick={showModal3}
                            style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                        >
                            <LockOutlined
                                style={{
                                    fontSize: "20px",
                                    color: "#26334A",
                                }}
                            />
                            <Text>เปลี่ยนรหัสผ่าน</Text>
                        </Menu.Item>
                        <Menu.Item
                            key="2"
                            onClick={showModal1}
                            style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                        >
                            <FileProtectOutlined
                                style={{
                                    fontSize: "20px",
                                    color: "#26334A",
                                }}
                            />
                            <Text>ข้อกำหนดการใช้งาน</Text>
                        </Menu.Item>
                        <Menu.Item
                            key="3"
                            onClick={showModal2}
                            style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                        >
                            <SafetyCertificateOutlined
                                style={{
                                    fontSize: "20px",
                                    color: "#26334A",
                                }}
                            />
                            <Text>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Text>
                        </Menu.Item>
                        <Menu.Item
                            key="4"
                            onClick={showConfirm}
                            style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                        >
                            <LogoutOutlined
                                style={{
                                    fontSize: "20px",
                                    color: "#26334A",
                                }}
                            />
                            <Text> ออกจากระบบ </Text>
                        </Menu.Item>
                    </Menu>
                </Row>
                <Modal
                    title="ข้อกำหนดการใช้งาน FMR"
                    // width='540px'
                    // className="modal-left"
                    visible={isModalTermsAndConditions}
                    onOk={handleOk1}
                    onCancel={handleCancel1}
                    footer={
                        <Button type="primary" size="middle" onClick={handleCancel1}>
                            ปิด
                        </Button>
                    }
                >
                    <ModalTermsOfUse />
                </Modal>
                <Modal
                    title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
                    // width='540px'
                    // className="modal-left"
                    visible={isModalOpenPolicy}
                    onOk={handleOk2}
                    onCancel={handleCancel2}
                    footer={
                        <Button type="primary" size="middle" onClick={handleCancel2}>
                            ปิด
                        </Button>
                    }
                >
                    <ModalPolicy />
                </Modal>
                <Modal
                    width="540px"
                    // className="modal-left"
                    visible={showModalResetPassword}
                    onOk={handleOk3}
                    onCancel={handleCancel3}
                    footer={null}
                >
                    <NewPasswordLogin />
                </Modal>
            </Col>
        </Row>
    );
    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };
    return (
        <Layout>
            {goToPath ? <Redirect to={goToPath} /> : null}
            {WindowResize >= 1024 && (
                <>
                    <Layout style={{ minHeight: "100vh" }}>
                        <Sider
                            width={250}
                            trigger={null}
                            collapsible
                            collapsed={collapsed}
                            style={{
                                backgroundColor: "#4EA5B2",
                                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
                            }}
                        >
                            <div
                                className={collapsed === false ? "ml-4" : "box-center"}
                                style={{
                                    paddingTop: 33,
                                    paddingBottom: 33,
                                    height: "84px",
                                    paddingLeft: collapsed === false ? 12 : "",
                                }}
                            >
                                <Image
                                    preview={false}
                                    src={collapsed === true ? icon_logo : logono1}
                                    width={collapsed === false ? "80%" : "50%"}
                                />
                            </div>
                            <Menu
                                mode="inline"
                                defaultSelectedKeys={defaultSelectedKeys}
                                className="mt-5"
                                style={{ backgroundColor: "#4fa5b2" }}
                            >
                                <Menu.Item
                                    onClick={() => {
                                        history.push("/dashboard-superadmin");
                                        setdefaultSelectedKeys(["1"]);
                                    }}
                                    key="1"
                                    style={{ border: "0px solid #B6D3D6", height: "50px" }}
                                >
                                    <AppstoreOutlined style={{ fontSize: "20px" }} />
                                    <span style={{ fontSize: "16px" }}>
                                        รายการขอประวัติการรักษา
                                    </span>
                                </Menu.Item>
                                <Menu.Item
                                    key="2"
                                    onClick={() => {
                                        history.push("/manage-user");
                                        setdefaultSelectedKeys(["2"]);
                                    }}
                                    style={{ border: "0px solid #B6D3D6", height: "50px" }}
                                >
                                    <FormOutlined style={{ fontSize: "20px" }} />
                                    <span style={{ fontSize: "16px" }}>จัดการผู้ใช้งาน</span>
                                </Menu.Item>
                            </Menu>
                            <div
                                className={collapsed === false ? "" : "box-center"}
                                style={{
                                    paddingTop: 33,
                                    paddingBottom: 33,
                                    height: "84px",
                                    paddingLeft: collapsed === false ? 12 : "",
                                }}
                            >
                                {collapsed ? (
                                    <>
                                        <Button
                                            size="middle"
                                            style={{
                                                borderRadius: "10px",
                                                backgroundColor: "#005A67",
                                                border: "none",
                                                color: "#ffffff",
                                                position: "fixed",
                                                bottom: 0,
                                                left: 0,
                                                marginLeft: "15px",
                                                marginBottom: "80px",
                                            }}
                                        >
                                            <a
                                                target="_blank"
                                                href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
                                            >
                                                <FileTextOutlined style={{ color: "#ffffff" }} />
                                            </a>
                                        </Button>
                                        <Button
                                            size="middle"
                                            style={{
                                                borderRadius: "10px",
                                                backgroundColor: "#005A67",
                                                border: "none",
                                                color: "#ffffff",
                                                position: "fixed",
                                                bottom: 0,
                                                left: 0,
                                                marginLeft: "15px",
                                                marginBottom: "30px",
                                            }}
                                            onClick={() => {
                                                window.location.reload();
                                            }}
                                        >
                                            <SyncOutlined style={{ color: "#ffffff" }} />
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <a
                                            style={{
                                                color: "#ffffff",
                                                position: "fixed",
                                                bottom: 0,
                                                left: 0,
                                                marginLeft: "65px",
                                                marginBottom: "80px",
                                            }}
                                            target="_blank"
                                            href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
                                        >
                                            <FileTextOutlined style={{ color: "#ffffff" }} />
                                            &nbsp;คู่มือการใช้งาน
                                        </a>
                                        <Button
                                            size="middle"
                                            style={{
                                                borderRadius: "10px",
                                                backgroundColor: "#005A67",
                                                border: "none",
                                                color: "#ffffff",
                                                position: "fixed",
                                                bottom: 0,
                                                left: 0,
                                                marginLeft: "65px",
                                                marginBottom: "30px",
                                            }}
                                            onClick={() => {
                                                window.location.reload();
                                            }}
                                        >
                                            <SyncOutlined style={{ color: "#ffffff" }} />
                                            &nbsp;Refresh
                                        </Button>
                                    </>
                                )}
                            </div>
                        </Sider>
                        <Layout>
                            <Header
                                style={{
                                    boxShadow: "2px 2px 15px rgba(0, 0, 0, 0.25)",
                                    // position: "fixed",
                                    zIndex: 1,
                                    top: 0,
                                    left: 280,
                                    right: 0,
                                    height: "80px",
                                }}
                            >
                                <Row justify="space-between">
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "80px",
                                        }}
                                    >
                                        <Button
                                            type="text"
                                            icon={
                                                collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                                            }
                                            onClick={() => setCollapsed(!collapsed)}
                                            style={{
                                                fontSize: "16px",
                                                width: 64,
                                                height: 64,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: " #147F8B",
                                                fontSize: "20px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {" "}
                                            {checkpathname()}
                                        </Text>
                                    </div>
                                    <div
                                        className="mr-4"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "80px",
                                        }}
                                    >
                                        <Space size={40}>
                                            <Space
                                                direction="vertical"
                                                className="space-gap"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Text
                                                    style={{
                                                        color: "#147F8B",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {resUserDisplay?.insurer}
                                                </Text>

                                                <Text
                                                    className="font-description"
                                                    style={{ color: "#147F8B", fontSize: "14px" }}
                                                >
                                                    {resUserDisplay?.name}
                                                </Text>
                                            </Space>
                                            <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                                                {" "}
                                                |
                                            </Text>

                                            <Dropdown
                                                overlay={menu}
                                                overlayStyle={{ paddingTop: "25px" }}
                                                placement="bottomRight"
                                            >
                                                <Avatar
                                                    style={{ cursor: "pointer" }}
                                                    size="large"
                                                    icon={<UserOutlined />}
                                                />
                                            </Dropdown>
                                        </Space>
                                    </div>
                                </Row>
                            </Header>
                            <Content className="">{children}</Content>
                        </Layout>
                    </Layout>
                </>
            )}
            {WindowResize < 1024 && (
                <Layout>
                    <Drawer onClose={onClose} visible={open} placement="left" key="left" closable={false}>
                        <Row style={{ display: 'flex', justifyContent: 'center' }} className="mt-5">
                            <Image
                                preview={false}
                                src={logofmrgg}
                                width='50%'
                            />
                        </Row>
                        <Dropdown
                            overlay={menu}
                            overlayStyle={{ paddingTop: "25px" }}
                            placement="bottomRight"
                        >
                            <Row className="pl-2 pr-2 pt-4 pb-4 m-2 mt-4" style={{ backgroundColor: '#AFD8D9', borderRadius: '20px' }}>
                                <Col>
                                    <Avatar
                                        style={{ cursor: "pointer", backgroundColor: '#095a66' }}
                                        size="large"
                                        icon={<UserOutlined />}
                                    />
                                </Col>
                                <Col className="ml-2">
                                    <Space direction="vertical"
                                        className="space-gap"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}>
                                        <Text
                                            style={{
                                                color: "#147F8B",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {resUserDisplay?.insurer}
                                        </Text>
                                        <Text
                                            className="font-description test"
                                            style={{ color: "#147F8B", fontSize: "12px" }}
                                        >
                                            {resUserDisplay?.name}
                                        </Text>
                                    </Space>
                                </Col>
                                <Col style={{ display: 'flex', alignItems: 'center' }} className="ml-2">
                                    <CaretDownOutlined />
                                </Col>
                            </Row>
                        </Dropdown>
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={defaultSelectedKeys}
                            className="mt-4"
                        >
                            <Menu.Item
                                onClick={() => {
                                    history.push("/dashboard-superadmin");
                                    setdefaultSelectedKeys(["1"]);
                                }}
                                key="1"
                                style={{ border: "0px solid #B6D3D6", height: "50px" }}
                            >
                                <AppstoreOutlined style={{ fontSize: "20px" }} />
                                <span style={{ fontSize: "16px" }}>
                                    รายการขอประวัติการรักษา
                                </span>
                            </Menu.Item>
                            <Menu.Item
                                key="2"
                                onClick={() => {
                                    history.push("/manage-user");
                                    setdefaultSelectedKeys(["2"]);
                                }}
                                style={{ border: "0px solid #B6D3D6", height: "50px" }}
                            >
                                <FormOutlined style={{ fontSize: "20px" }} />
                                <span style={{ fontSize: "16px" }}>จัดการผู้ใช้งาน</span>
                            </Menu.Item>
                        </Menu>
                        <a
                            style={{
                                color: "#005A67",
                                position: "fixed",
                                bottom: 0,
                                left: 0,
                                marginLeft: "110px",
                                marginBottom: "80px",
                            }}
                            target="_blank"
                            href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
                        >
                            <FileTextOutlined style={{ color: "#ffffff" }} />
                            &nbsp;คู่มือการใช้งาน
                        </a>
                        <Button
                            size="middle"
                            style={{
                                borderRadius: "10px",
                                backgroundColor: "#005A67",
                                border: "none",
                                color: "#ffffff",
                                position: "fixed",
                                bottom: 0,
                                left: 0,
                                marginLeft: "120px",
                                marginBottom: "30px",
                            }}
                            onClick={() => {
                                window.location.reload();
                            }}
                        >
                            <SyncOutlined style={{ color: "#ffffff" }} />
                            &nbsp;Refresh
                        </Button>
                    </Drawer>
                    <Header
                        style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            width: "100%",
                            boxShadow: " 0px 1px 20px 1px rgba(128, 128, 128, 0.65"
                        }}
                    >
                        <Row >
                            <Col
                                xs={20}
                                md={20}
                                lg={20}
                                xl={20}
                                xxl={20}
                                className=" pl-3"
                                style={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Image
                                    preview={false}
                                    src={icon_logo}
                                    width={50}
                                />
                                <Text
                                    style={{
                                        color: " #147F8B",
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                    }}
                                    className="ml-3"
                                >
                                    {" "}
                                    {checkpathname()}
                                </Text>
                            </Col>
                            <Col xs={4} md={4} lg={4} xl={4} xxl={4}>
                                <div className="layoutHeader">
                                    <Button type="text" onClick={showDrawer}>
                                        <MenuOutlined />
                                    </Button>
                                </div>

                            </Col>
                        </Row>
                    </Header>
                    <Content style={{ minHeight: '100vh' }}>
                        {children}
                    </Content>
                </Layout>
            )
            }
        </Layout >
    )
};
export default SuperAdminLayout;
